"use client";

import { useParams } from "next/navigation";
import { FC } from "react"

const PrivacySpanishClient: FC = () => {
  const { locale } = useParams();

  return (
    <div className="flex flex-col bg-black-900 px-9 py-8 gap-4 rounded-2xl items-start">
      <h4 className="text-title-lg">Política de Privacidad.</h4>
      <p>
        Fecha de entrada en vigor: 01 de marzo de 2024.
      </p>
      <p>
        Arena Pro Gaming, cuya aparición en este acuerdo se hará en adelante como &quot;nosotros&quot;, opera el sitio web <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a>, en adelante mencionado como &quot;sitio web&quot;.
      </p>
      <p>
        Nosotros como organización valoramos y respetamos la privacidad de los usuarios de nuestro sitio web, reconociéndolos como profesionales miembros de la comunidad de videojuegos y los deportes electrónicos (eSports) y nos comprometemos a proteger la  información personal que usted como usuario nos proporcione. Esta <strong>política de privacidad</strong>establece cómo recopilamos, utilizamos, divulgamos y protegemos su información personal.
      </p>

      <h4 className="text-title-md">1. Información personal  recopilada.</h4>
      <p>
        Podemos recopilar la siguiente información personal de los usuarios de nuestro sitio web:
      </p>
      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. Nombre completo.
        </li>
        <li>
          ii. Dirección de correo electrónico.
        </li>
        <li>
          iii. Información de contacto (como dirección, número de teléfono, etc.)
        </li>
        <li>
          iv. Información profesional (como experiencia laboral, habilidades, etc.)
        </li>
        <li>
          v. Ubicación (país de residencia o de origen)
        </li>
        <li>
          vi. Preferencias de videojuegos.
        </li>
        <li>
          vii. Información de eventos (futuros o pasados).
        </li>
        <li>
          viii. Información sobre equipamiento usado para realizar sus actividades profesionales o que tengan relación con los roles elegidos.
        </li>
        <li>
          ix. Imágenes subidas o compartidas en el sitio web.
        </li>
      </ul>

      <h4 className="text-title-md">2. Uso de la información personal.</h4>
      <p>
        Utilizamos la información personal recopilada para los siguientes propósitos:
      </p>
      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. Proporcionar y mantener nuestro sitio web y sus servicios.
        </li>
        <li>
          ii. Comunicarnos con usted y responder a sus consultas y solicitudes.
        </li>
        <li>
          iii. Personalizar su experiencia en nuestro sitio web y ofrecerle contenido relevante.
        </li>
        <li>
          iv. Mejorar nuestros servicios y realizar análisis y estudios de mercado.
        </li>
        <li>
          v. Cumplir con las leyes y regulaciones aplicables.
        </li>
        <li>
          vi. Nutrir nuestra herramienta de búsqueda para mostrar poder mostrar los perfiles e información de interés de manera precisa.
        </li>
        <li>
          vii. Crear futuras herramientas que ayuden a la comunidad de videojuegos y deportes electrónicos.
        </li>
      </ul>

      <h4 className="text-title-md">3. Divulgación de la información personal.</h4>
      <p>
        Podemos compartir su información personal con terceros en las siguientes circunstancias:
      </p>
      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. Proveedores de servicios: Podemos compartir su información personal con proveedores de servicios externos que nos ayudan a operar nuestro sitio web y brindarle nuestros servicios.
        </li>
        <li>
          ii. Cumplimiento legal: Podemos divulgar su información personal si así lo exige la ley o si creemos de buena fe que dicha divulgación es necesaria para cumplir con un procedimiento legal en curso, proteger nuestros derechos o responder a una solicitud legal válida.
        </li>
      </ul>

      <h4 className="text-title-md">4. Seguridad de la información personal.</h4>
      <p>
        Nos comprometemos a proteger la seguridad de su información personal. Implementamos medidas de seguridad técnicas, administrativas y físicas para proteger su información contra el acceso no autorizado, la divulgación o el uso indebido.
      </p>

      <h4 className="text-title-md">5. Retención de la  información personal.</h4>
      <p>
        Mantendremos su información personal solo durante el tiempo necesario para cumplir con los fines establecidos en esta <strong>política de privacidad</strong> , a menos que se  requiera o permita un período de retención más largo por ley.
      </p>

      <h4 className="text-title-md">6. Derechos del usuario.</h4>
      <p>
        Usted tiene ciertos  derechos con respecto a la información personal que suministre en este sitio  web, incluido el derecho a acceder, corregir, eliminar y limitar el procesamiento de su información personal. Puede ejercer estos derechos fácilmente  desde nuestro sitio web o comunicándose con nosotros a través de los datos de contacto proporcionados al final de este acuerdo.
      </p>

      <h4 className="text-title-md">7. Cambios en la política  de privacidad.</h4>
      
      <p>
        Nos reservamos el derecho de modificar esta <strong>política de privacidad</strong> en cualquier momento. Cualquier cambio entrará en vigor inmediatamente después de su publicación en nuestro sitio web. Le recomendamos que revise periódicamente esta <strong>política de privacidad</strong> para estar informado sobre cualquier cambio.
      </p>
      <p>
        Si tiene alguna pregunta, duda o inquietud sobre nuestra <strong>política de privacidad</strong> o sobre cómo manejamos su información personal, no dude en comunicarse con nosotros a través  de los siguientes datos de contacto:
      </p>
      <p>
        Arena Pro Gaming. 2024, todos los derechos reservados.
      </p>
      <p>
        Correo electrónico: <a className="text-aqua-300" href="mailto:hola@apg.gg">hola@apg.gg</a>
      </p>
      <p>
        Discord: <a className="text-aqua-300" href="https://discord.gg/6ja3zj9XyR">https://discord.gg/6ja3zj9XyR</a>
      </p>
      <p>
        Twitter: <a className="text-aqua-300" href="https://twitter.com/apg_club">@apg_club</a>
      </p>
    </div>
  )
}

export default PrivacySpanishClient